import { render, staticRenderFns } from "./LoginCode.vue?vue&type=template&id=8edc154a&scoped=true"
import script from "./LoginCode.vue?vue&type=script&lang=js"
export * from "./LoginCode.vue?vue&type=script&lang=js"
import style0 from "./LoginCode.vue?vue&type=style&index=0&id=8edc154a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edc154a",
  null
  
)

export default component.exports